import { itemImagePresentation, isEquippableItem, type Item, type WithId } from "@um/contracts";

/**
 * Facts about an item document itself. Anything about *who is wearing what*
 * lives in `looks.ts`, which is the single source of truth for that.
 */

/** The item's art, once `onItemCreated` has produced it. */
export function itemImageUrl(
  item: WithId<Item> | undefined
): string | undefined {
  return itemImagePresentation(item?.image).url;
}

/**
 * Wearables only. Quest rewards are all wearables now, but the generator still
 * understands `kind: "scene"` and those were never equippable, so anything left
 * over in an older account stays out of the wardrobe.
 */
export function wearableItems(items: WithId<Item>[]): WithId<Item>[] {
  return items.filter(item => isEquippableItem(item) && !item.photoTrial && !item.replacedBy);
}

/** The items that belong to one person. */
export function itemsForMind(
  items: WithId<Item>[],
  mindId: string | undefined
): WithId<Item>[] {
  if (!mindId) return items;
  // An item with no `mind` predates the field.
  return items.filter((item) => !item.mind || item.mind.id === mindId);
}
